import { render, staticRenderFns } from "./GenerateHes.vue?vue&type=template&id=97a4b06a"
import script from "./GenerateHes.vue?vue&type=script&lang=js"
export * from "./GenerateHes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports